import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_seller_support_requests = createAsyncThunk(
    'sellerSupport/list',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/seller/support-requests', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) { return rejectWithValue(error.response?.data || { error: 'Xəta' }) }
    }
)

export const get_seller_support_request = createAsyncThunk(
    'sellerSupport/detail',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/seller/support-requests/${id}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) { return rejectWithValue(error.response?.data || { error: 'Xəta' }) }
    }
)

export const reply_seller_support_request = createAsyncThunk(
    'sellerSupport/reply',
    async ({ id, reply }, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.post(`/seller/support-requests/${id}/reply`, { reply }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) { return rejectWithValue(error.response?.data || { error: 'Xəta' }) }
    }
)

const sellerSupportReducer = createSlice({
    name: 'sellerSupport',
    initialState: { requests: [], request: null, loader: false, successMessage: '', errorMessage: '' },
    reducers: {
        messageClear: (state) => { state.successMessage = ''; state.errorMessage = '' },
        clearRequest: (state) => { state.request = null },
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_seller_support_requests.pending, (state) => { state.loader = true })
            .addCase(get_seller_support_requests.fulfilled, (state, { payload }) => { state.loader = false; state.requests = payload.requests || [] })
            .addCase(get_seller_support_requests.rejected, (state) => { state.loader = false })
            .addCase(get_seller_support_request.fulfilled, (state, { payload }) => { state.request = payload.request || null })
            .addCase(get_seller_support_request.rejected, (state, { payload }) => { state.errorMessage = payload?.error || 'Tapılmadı' })
            .addCase(reply_seller_support_request.fulfilled, (state, { payload }) => { state.request = payload.request || state.request; state.successMessage = payload.message })
            .addCase(reply_seller_support_request.rejected, (state, { payload }) => { state.errorMessage = payload?.error || 'Göndərilmədi' })
    }
})

export const { messageClear, clearRequest } = sellerSupportReducer.actions
export default sellerSupportReducer.reducer

export const SUPPORT_CATEGORY_LABEL = {
    order_problem: 'Sifariş problemi', product_not_delivered: 'Məhsul təhvil verilmədi',
    product_not_working: 'Məhsul işləmir', payment_balance: 'Ödəniş / balans',
    seller_complaint: 'Satıcıdan şikayət', account_login: 'Hesab / giriş',
    seller_application: 'Satıcı olmaq', other: 'Digər'
}
export const SELLER_REQ_STATUS = {
    requested: { label: 'Cavab gözlənilir', cls: 'bg-amber-500/20 text-amber-300' },
    seller_replied: { label: 'Cavab verildi', cls: 'bg-emerald-500/20 text-emerald-300' },
    admin_replied: { label: 'Admin cavab verdi', cls: 'bg-violet-500/20 text-violet-300' },
    closed: { label: 'Bağlandı', cls: 'bg-slate-600/40 text-slate-300' },
    none: { label: '—', cls: 'bg-slate-600/40 text-slate-300' },
}
